if (!customElements.get("sc-bundle-components")) {
  const BUNDLE_QUERY = `
    query getBundleComponents($id: ID!, $language: LanguageCode) @inContext(language: $language) {
      product(id: $id) {
        variants(first: 1) {
          nodes {
            components(first: 10) {
              nodes {
                quantity
                productVariant {
                  selectedOptions {
                    name
                    value
                  }
                  product {
                    id
                    handle
                    title
                    tags
                    priceRange { minVariantPrice { amount } }
                    featuredImage { url }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  function scWeightFromSelectedOptions(selectedOptions) {
    if (!selectedOptions?.length) return "";
    const match = selectedOptions.find((o) => {
      const n = (o.name || "").toLowerCase();
      return n.includes("gewicht") || n.includes("weight");
    });
    const v = match?.value?.trim();
    return v || "";
  }

  class SCBundleComponents extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector(".sc-bundle-components-slider__track");
      if (!this.grid || this.dataset.fetchBundle !== "true") return;
      if (this._bundleFetchStarted) return;
      this._bundleFetchStarted = true;

      const token = this.dataset.storefrontToken;
      const productNumericId = this.dataset.productId;
      const shopDomain = window.Shopify?.shop || this.dataset.shopDomain || "";
      if (!token || !productNumericId || !shopDomain) {
        this.remove();
        return;
      }

      const productGid = `gid://shopify/Product/${productNumericId}`;
      const language = this.dataset.language || "DE";

      fetch(`https://${shopDomain}/api/2026-01/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": token,
        },
        body: JSON.stringify({
          query: BUNDLE_QUERY,
          variables: { id: productGid, language },
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          const variants = data?.data?.product?.variants?.nodes;
          const components = variants?.[0]?.components?.nodes;

          if (
            !variants ||
            variants.length === 0 ||
            !components ||
            components.length === 0
          ) {
            this.remove();
            return;
          }

          this.grid.innerHTML = "";

          components.forEach((comp) => {
            const prod = comp.productVariant.product;
            const quantity = comp.quantity;
            const weightStr = scWeightFromSelectedOptions(
              comp.productVariant.selectedOptions,
            );
            const weightHTML = weightStr
              ? `<span class="sc-bundle-component__card-weight">${weightStr}</span>`
              : "";

            let badgesHTML = "";
            if (prod.tags?.includes("Bestseller")) {
              badgesHTML +=
                '<span class="sc-badge sc-badge-bestseller">BESTSELLER</span>';
            }
            if (prod.tags?.includes("Neu")) {
              badgesHTML += '<span class="sc-badge sc-badge-neu">NEU</span>';
            }

            const imageHTML = prod.featuredImage
              ? `<img src="${prod.featuredImage.url}" alt="${prod.title}" loading="lazy" class="sc-bundle-component__card-image">`
              : `<div class="sc-bundle-component__card-image placeholder"></div>`;

            this.grid.innerHTML += `
          <div class="sc-bundle-components-slider__item">
            <div class="sc-bundle-component__card">
              <div class="sc-bundle-component__card-image-wrap">
                <div class="sc-bundle-component__card-badges">
                  ${badgesHTML}
                </div>
                <a href="/products/${prod.handle}">
                  ${imageHTML}
                </a>
              </div>
              <div class="sc-bundle-component__card-info">
                <span class="sc-bundle-component__card-quantity">${quantity} &times;</span>
                <span class="sc-bundle-component__card-title">${prod.title}</span>
                ${weightHTML}
              </div>
            </div>
          </div>
        `;
          });

          this.classList.remove("sc-bundle-components--empty");
        })
        .catch((err) => {
          console.error("Error fetching bundle components:", err);
          this.remove();
        });
    }
  }

  customElements.define("sc-bundle-components", SCBundleComponents);
}
